import React from 'react'
import { Loader } from '@mantine/core'

const InlineLoader: React.FC = () => {
  return <Loader variant="dots" color="dark" size="xs" />
}

export { InlineLoader }
